import { ReactNode, useMemo, useReducer } from "react";

import { AppStateContext, initialAppState } from "./context";
import { appReducer } from "./reducer";
import { IAppContext } from "./types";

export const AppContextProvider = ({
  children,
  render,
}: {
  children?: ReactNode;
  render?: (data: IAppContext) => ReactNode;
}) => {
  const [state, dispatch] = useReducer(appReducer, initialAppState);

  const memoizedContext = useMemo(
    () => ({ state, dispatch }),
    [state, dispatch],
  );

  return (
    <AppStateContext.Provider value={memoizedContext}>
      {render?.(memoizedContext) || children}
    </AppStateContext.Provider>
  );
};
